import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";

class Coffe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        username: "",
      },
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    const { user } = this.state;
    if (user.username && user.password) {
      // this.props.register(user);
      // console.log(user);
      var bodyFormData = new FormData();
      bodyFormData.append("username", user.username);
      bodyFormData.append("password", user.password);
      axios
        .post(severUrl + "registration/login_user", bodyFormData)
        .then((response) => {
          // console.log(response.data);
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
          // console.log(response.json())
        });
    }
  }

  render() {
    const { registering } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
      <h4 style={{fontSize:"24px"}}>Support Address</h4>
        <div style={{fontWeight:"bold"}}>Payonneer account</div>
        <ol>
          <li>Bank name:
            First Century Bank</li>
          <li>Bank address:
            1731 N Elm St  Commerce, GA 30529 USA</li>
          <li>Routing (ABA):
            061120084</li>
          <li>Account number:
            4027037064920</li>
          <li>Account type:
            CHECKING</li>
          <li>Beneficiary name:
            Loc Ho</li>
        </ol>
        <div style={{fontWeight:"bold"}}>Techcombank account: </div>
        <ol>
          <li>SWIFT code: VTCBVNVX</li>
          <li>Name: Ho Tan Loc</li>
          <li>Account number: 19033533607027</li>
        </ol>
      </>
    );
  }
}

function mapState(state) {
  const { registering } = state.registration;
  return { registering };
}

const actionCreators = {
  register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(Coffe);
export { connectedRegisterPage as Coffe };
